import { render, staticRenderFns } from "./MasterSearchBox.vue?vue&type=template&id=54d41060&"
import script from "./MasterSearchBox.vue?vue&type=script&lang=js&"
export * from "./MasterSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./MasterSearchBox.vue?vue&type=style&index=0&id=54d41060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports